import { useHasSettled } from '@/hooks/useHasSettled';

import { addressSubject } from './connection-actions';
import { ConnectionControls } from './connection-controls';
import { LOOKUP_DELAY_MS, type ConnectionSurface } from './connections.query';
import { useRunAddressAction } from './use-run-connection-action';

/** The Connect or the Invite for an address that no page holds yet, such as one typed in the share picker. The address
 * is looked up once it has stood still, because the user types it a character at a time, and it gets a page when the
 * user acts. */
export const AddressConnectionButton = ({
  email,
  surface,
}: {
  email: string;
  /** Where the button is, for analytics */
  surface: ConnectionSurface;
}) => {
  const { click, isPending } = useRunAddressAction(surface);
  const hasSettled = useHasSettled(email, LOOKUP_DELAY_MS);
  if (!hasSettled) return null;

  return (
    <ConnectionControls
      subject={addressSubject(email)}
      click={click}
      isPending={isPending}
      surface={surface}
    />
  );
};
